import React from 'react';
import { ChevronDown, ChevronUp, ArrowLeft, Info } from 'react-feather';

const colors: any = {
  red: '#E31B1F',
};

const components: any = {
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  'arrow-left': ArrowLeft,
  'info': Info
};

interface IconProps {
  size: number;
  icon: string;
  color?: string;
}

export default function Icon({ size, icon, color = 'black' }: IconProps) {
  const Component = components[icon];

  if (!Component) return null;

  return (
    <Component color={colors[color]} size={size} />
  );
}
